/** Canonical pure semantics, shared by the host and native editor. */



/**
 * 🎞 **"이 컷에 실제로 만들어진 영상이 실렸나" — 단일 술어**(2026-08-24 리뷰 R15).
 *
 * ★왜 함수인가★: 같은 물음이 세 자리에서 ★서로 다른 식★ 으로 답하고 있었다.
 *   · `planGlobalAspectApply`(재생성 대상 세기) = `typeof videoUrl === "string" && videoUrl` (truthy)
 *   · `resolveAspectChipState`(낡음 판정)      = 같은 truthy
 *   · 쉬운 모드 마커 파생(`buildGenPreviewCode`) = `/^https?:/` ★만★ 영상으로 인정
 *   ⇒ `blob:`·`data:`·상대경로가 실린 컷은 ★확인창은 "재생성 필요 N개"에 세면서 배지는 침묵★ 하는
 *     엇갈림이 성립한다(둘 다 참인 화면이 없다 = 어느 쪽이 거짓인지 유저가 알 수 없다).
 * ★엄격한 쪽(https)으로 모은다★ — 느슨한 쪽으로 모으면 하류(EF 제출·합본)가 못 쓰는 URL 을
 *   "만들어진 영상"으로 세게 되고, 그건 숫자를 부풀려 유저에게 없는 손실을 경고하는 꼴이다.
 *   마커 파생이 이미 https 만 완성 컷으로 넘기고 있었으므로 ★실제로 굴러온 계약★ 이 이쪽이다.
 */
export function cutHasVideo(node: { videoUrl?: string | null } | null | undefined): boolean {
  return isHttpUrl(node?.videoUrl);
}


/**
 * 🔗 **"실제로 받아올 수 있는 http(s) 주소인가" — 이 축의 단 하나의 식**(2026-08-24 재리뷰 N7).
 *
 * ★왜 별도 함수로 뽑았나★: `cutHasVideo` 가 `/^https?:/` 를 ★자기 안에 다시 적고★ 있었고, 같은 식이
 *   `gen-preview-code.ts` 의 지역 `httpsOnly` 에도 있었다. 실측해 보니 두 식은 문자 그대로 같았지만
 *   ★같다는 사실이 어디에도 보증돼 있지 않았다★ — 한쪽만 손대면(예: `blob:` 허용, 대소문자 무시)
 *   "영상이 있나"의 답이 표면마다 갈리는데 아무 테스트도 안 문다. 식을 하나로 모아 그 갈림을 없앤다.
 *
 * ★값으로 못 박은 판정(테스트가 잠근다)★:
 *   · `https://…`·`http://…` = 참 · `blob:`·`data:`·`file:` = 거짓(하류가 못 받아온다)
 *   · `//host/a.mp4`(프로토콜 상대) = ★거짓★ — 스킴이 없으면 EF·합본이 그대로 못 쓴다.
 *   · `HTTPS://…`(대문자 스킴) = ★거짓★ — RFC 상으로는 유효하지만 이 레포 저장분에 실재하지 않고,
 *     여기서 관대해지면 "어디까지 받아주나"가 표면마다 다시 갈린다(엄격한 쪽 유지 = 종전 동작 보존).
 */
export function isHttpUrl(value: unknown): value is string {
  return typeof value === "string" && /^https?:/.test(value);
}
